import { useServicesContext } from "@modules/core/services/services.context"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export const useProgramInfiniteSubscription = (programId: string) => {
  const { programInfiniteApi } = useServicesContext()
  const queryClient = useQueryClient()

  const { mutateAsync: subscribeProgramInfinite, isPending: isSubscribeProgramInfinitePending } = useMutation({
    mutationFn: async () => {
      const resultDto = await programInfiniteApi.subscribeProgramInfinite(programId)
      return resultDto.status
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["program", programId] })
      await queryClient.invalidateQueries({ queryKey: ["programs"] })
    },
  })

  return {
    subscribeProgramInfinite,
    isPending: isSubscribeProgramInfinitePending,
  }
}

export const useProgramInfiniteUnsubscription = (programId: string) => {
  const { programInfiniteApi } = useServicesContext()
  const queryClient = useQueryClient()

  const { mutateAsync: unsubscribeProgramInfinite, isPending: isUnsubscribeProgramInfinitePending } = useMutation({
    mutationFn: async () => {
      const resultDto = await programInfiniteApi.unsubscribeProgramInfinite(programId)
      return resultDto.status
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["program", programId] })
      await queryClient.invalidateQueries({ queryKey: ["programs"] })
    },
  })

  return {
    unsubscribeProgramInfinite,
    isPending: isUnsubscribeProgramInfinitePending,
  }
}
